// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedia3DPlay_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.04 11.1724C5.384 10.8204 5.556 10.3524 5.556 9.76838C5.556 9.13638 5.312 8.63238 4.824 8.25638C4.344 7.88038 3.66 7.69238 2.772 7.69238C2.164 7.69238 1.636 7.77638 1.188 7.94438C0.74 8.11238 0.352 8.31638 0.024 8.55638L0.744 9.60038C0.992 9.44038 1.272 9.29238 1.584 9.15638C1.896 9.01238 2.268 8.94038 2.7 8.94038C3.148 8.94038 3.484 9.03638 3.708 9.22838C3.932 9.42038 4.044 9.68838 4.044 10.0324C4.044 10.4244 3.9 10.7444 3.612 10.9924C3.324 11.2404 2.8 11.3644 2.04 11.3644H1.308V12.5764H2.028C2.812 12.5764 3.372 12.6804 3.708 12.8884C4.044 13.0964 4.212 13.4124 4.212 13.8364C4.212 14.2844 4.068 14.6364 3.78 14.8924C3.492 15.1404 3 15.2644 2.304 15.2644C1.944 15.2644 1.56 15.2164 1.152 15.1204C0.744 15.0244 0.36 14.8844 0 14.7004V16.0324C0.352 16.1924 0.724 16.3084 1.116 16.3804C1.516 16.4604 1.952 16.5004 2.424 16.5004C3.208 16.5004 3.848 16.3884 4.344 16.1644C4.848 15.9404 5.22 15.6324 5.46 15.2404C5.7 14.8484 5.82 14.4044 5.82 13.9084C5.82 13.3484 5.644 12.8964 5.292 12.5524C4.94 12.2084 4.42 11.9924 3.732 11.9044V11.8684C4.268 11.7484 4.704 11.5164 5.04 11.1724Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2872 15.2884C14.0952 14.5524 14.4992 13.4604 14.4992 12.0124C14.4992 11.1004 14.3192 10.3324 13.9592 9.70838C13.6072 9.08438 13.1072 8.61238 12.4592 8.29238C11.8112 7.97238 11.0432 7.81238 10.1552 7.81238H7.49119V16.3804H9.90319C11.3512 16.3804 12.4792 16.0164 13.2872 15.2884ZM12.1832 9.80438C12.6552 10.2844 12.8912 11.0364 12.8912 12.0604C12.8912 14.0844 11.9112 15.0964 9.95119 15.0964H9.02719V9.08438H10.1552C11.0352 9.08438 11.7112 9.32438 12.1832 9.80438Z" class="svg-bg"/>
  <path d="M24 12L18 8V16L24 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedia3DPlay is a generated icon component.
 */
let IconMedia3DPlay = IconMedia3DPlay_1 = class IconMedia3DPlay extends IconBaseElement {
    render() {
        return html `${IconMedia3DPlay_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedia3DPlay.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedia3DPlay = IconMedia3DPlay_1 = __decorate([
    customElement('zui-icon-media-3-d-play')
], IconMedia3DPlay);
export { IconMedia3DPlay };
